import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import DateRangeDropdownTrigger from './DateRangeDropdownTrigger';
import 'react-datepicker/dist/react-datepicker.css';
import '../../assets/css/calendar.css';

const DateRangePicker = ({ onChange, placeholderText = 'Select Date Range' }) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const customInput = useMemo(
    () => <DateRangeDropdownTrigger placeholder={placeholderText} />,
    [placeholderText],
  );

  const handleDateChange = (update) => {
    setDateRange(update);
    if (onChange) onChange(update);
  };

  return (
    <DatePicker
      selectsRange
      startDate={dateRange[0]}
      endDate={dateRange[1]}
      onChange={handleDateChange}
      isClearable
      placeholderText={placeholderText}
      customInput={customInput}
      wrapperClassName="standup-date-range-picker-wrap"
      popperClassName="standup-date-range-picker-popper"
      calendarClassName="standup-date-range-calendar"
    />
  );
};

DateRangePicker.propTypes = {
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
};

export default DateRangePicker;